import React from 'react';
import {
  Snackbar as MUISnackbar,
  Card,
  Box,
  IconButton,
  Typography
} from '@mui/material';
import { useAppDispatch } from '../../hooks';
import { useSelector } from 'react-redux';
import { SnackBarActions } from './slice';
import { Close } from 'mdi-material-ui';

const SnackBar = () => {
  const {
    open,
    message,
    type = 'info',
    duration
  } = useSelector((state: any) => state.snackBar.openSnack);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(
      SnackBarActions.openSnack({
        open: false
      })
    );
  };

  const InfoIcon = () => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.575 19.1841H15.7441V12.5524C15.7441 12.2598 15.6278 11.9791 15.4209 11.7722C15.214 11.5652 14.9333 11.449 14.6406 11.449H11.4186C11.1259 11.449 10.8453 11.5652 10.6383 11.7722C10.4314 11.9791 10.3151 12.2598 10.3151 12.5524C10.3151 12.8451 10.4314 13.1257 10.6383 13.3327C10.8453 13.5396 11.1259 13.6559 11.4186 13.6559H13.5372V19.1841H11.4186C11.1259 19.1841 10.8453 19.3004 10.6383 19.5073C10.4314 19.7143 10.3151 19.9949 10.3151 20.2876C10.3151 20.5802 10.4314 20.8609 10.6383 21.0678C10.8453 21.2748 11.1259 21.391 11.4186 21.391H16.575C16.8676 21.391 17.1483 21.2748 17.3552 21.0678C17.5622 20.8609 17.6784 20.5802 17.6784 20.2876C17.6784 19.9949 17.5622 19.7143 17.3552 19.5073C17.1483 19.3004 16.8676 19.1841 16.575 19.1841ZM13.9962 9.04896C14.3236 9.04896 14.6436 8.95189 14.9158 8.77002C15.188 8.58814 15.4001 8.32964 15.5254 8.0272C15.6507 7.72475 15.6835 7.39195 15.6196 7.07088C15.5557 6.74981 15.3981 6.45489 15.1666 6.22341C14.9351 5.99193 14.6402 5.83429 14.3191 5.77042C13.9981 5.70656 13.6653 5.73933 13.3628 5.86461C13.0604 5.98989 12.8019 6.20203 12.62 6.47423C12.4381 6.74642 12.3411 7.06643 12.3411 7.39379C12.3411 7.83277 12.5154 8.25377 12.8258 8.56417C13.1362 8.87458 13.5572 9.04896 13.9962 9.04896ZM13.9962 0.207031C10.3393 0.21112 6.83337 1.66563 4.24755 4.25145C1.66172 6.83728 0.207214 10.3432 0.203125 14.0001C0.209252 17.6564 1.66442 21.1612 4.2498 23.7466C6.83518 26.3319 10.34 27.7871 13.9962 27.7932C17.6544 27.7932 21.1627 26.34 23.7494 23.7533C26.3361 21.1666 27.7893 17.6583 27.7893 14.0001C27.7893 10.342 26.3361 6.83365 23.7494 4.24694C21.1627 1.66023 17.6544 0.207031 13.9962 0.207031ZM22.0845 22.2826C20.1706 24.1473 17.6704 25.2925 15.0083 25.5238C12.3462 25.7552 9.68602 25.0584 7.47912 23.5518C5.27221 22.0451 3.65448 19.8214 2.9004 17.2579C2.14632 14.6943 2.30232 11.9488 3.34193 9.48721C4.38155 7.02558 6.24075 4.99942 8.60412 3.75246C10.9675 2.50551 13.6895 2.11456 16.3082 2.64595C18.927 3.17734 21.2813 4.59834 22.9717 6.66786C24.6621 8.73739 25.5845 11.328 25.5824 14.0001C25.5862 15.545 25.2784 17.0747 24.6774 18.4978C24.0764 19.9209 23.1945 21.2082 22.0845 22.2826Z"
        fill="#2F80ED"
      />
    </svg>
  );

  const ErrorIcon = () => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.575 19.1841H15.7441V12.5524C15.7441 12.2598 15.6278 11.9791 15.4209 11.7722C15.214 11.5652 14.9333 11.449 14.6406 11.449H11.4186C11.1259 11.449 10.8453 11.5652 10.6383 11.7722C10.4314 11.9791 10.3151 12.2598 10.3151 12.5524C10.3151 12.8451 10.4314 13.1257 10.6383 13.3327C10.8453 13.5396 11.1259 13.6559 11.4186 13.6559H13.5372V19.1841H11.4186C11.1259 19.1841 10.8453 19.3004 10.6383 19.5073C10.4314 19.7143 10.3151 19.9949 10.3151 20.2876C10.3151 20.5802 10.4314 20.8609 10.6383 21.0678C10.8453 21.2748 11.1259 21.391 11.4186 21.391H16.575C16.8676 21.391 17.1483 21.2748 17.3552 21.0678C17.5622 20.8609 17.6784 20.5802 17.6784 20.2876C17.6784 19.9949 17.5622 19.7143 17.3552 19.5073C17.1483 19.3004 16.8676 19.1841 16.575 19.1841ZM13.9962 9.04896C14.3236 9.04896 14.6436 8.95189 14.9158 8.77002C15.188 8.58814 15.4001 8.32964 15.5254 8.0272C15.6507 7.72475 15.6835 7.39195 15.6196 7.07088C15.5557 6.74981 15.3981 6.45489 15.1666 6.22341C14.9351 5.99193 14.6402 5.83429 14.3191 5.77042C13.9981 5.70656 13.6653 5.73933 13.3628 5.86461C13.0604 5.98989 12.8019 6.20203 12.62 6.47423C12.4381 6.74642 12.3411 7.06643 12.3411 7.39379C12.3411 7.83277 12.5154 8.25377 12.8258 8.56417C13.1362 8.87458 13.5572 9.04896 13.9962 9.04896ZM13.9962 0.207031C10.3393 0.21112 6.83337 1.66563 4.24755 4.25145C1.66172 6.83728 0.207214 10.3432 0.203125 14.0001C0.209252 17.6564 1.66442 21.1612 4.2498 23.7466C6.83518 26.3319 10.34 27.7871 13.9962 27.7932C17.6544 27.7932 21.1627 26.34 23.7494 23.7533C26.3361 21.1666 27.7893 17.6583 27.7893 14.0001C27.7893 10.342 26.3361 6.83365 23.7494 4.24694C21.1627 1.66023 17.6544 0.207031 13.9962 0.207031ZM22.0845 22.2826C20.1706 24.1473 17.6704 25.2925 15.0083 25.5238C12.3462 25.7552 9.68602 25.0584 7.47912 23.5518C5.27221 22.0451 3.65448 19.8214 2.9004 17.2579C2.14632 14.6943 2.30232 11.9488 3.34193 9.48721C4.38155 7.02558 6.24075 4.99942 8.60412 3.75246C10.9675 2.50551 13.6895 2.11456 16.3082 2.64595C18.927 3.17734 21.2813 4.59834 22.9717 6.66786C24.6621 8.73739 25.5845 11.328 25.5824 14.0001C25.5862 15.545 25.2784 17.0747 24.6774 18.4978C24.0764 19.9209 23.1945 21.2082 22.0845 22.2826Z"
        fill="#fff"
      />
    </svg>
  );

  const action = <React.Fragment></React.Fragment>;

  return (
    <MUISnackbar
      open={open}
      onClose={handleClose}
      action={action}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={duration ? duration : 2000}
    >
      <Card
        sx={{
          height: 85,
          width: 562,
          background: type === 'error' ? 'red' : '#C6DEFF',
          display: 'flex'
        }}
      >
        <Box
          width="10%"
          height={'100%'}
          alignItems={'center'}
          justifyContent="center"
          display="flex"
        >
          {type === 'error' ? <ErrorIcon /> : <InfoIcon />}
        </Box>
        <Box p="12px">
          {type === 'error' ? (
            <Typography variant="h4" fontWeight="500" color="#fff">
              Error
            </Typography>
          ) : (
            <Typography variant="h4" fontWeight="500">
              Info
            </Typography>
          )}
          <Typography
            variant="h5"
            mt="8px"
            sx={{ color: type === 'error' ? '#fff' : '#000' }}
          >
            {message}
          </Typography>
        </Box>

        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            color: type === 'error' ? '#fff' : '#000'
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Card>
    </MUISnackbar>
  );
};

export default SnackBar;
